<template>
    <div class="row justify-content-center">
        <div class="col-lg-12 text-center">
            <p>Login credentials are reserved for Torin Drive North America customers. Only one login will be issued to each customer.<br> If you do not have a login, please check with your company's administrator.</p>
        </div>
        <div class="login-wrap">
            <form role="form">
                <base-input class="mb-3"
                            placeholder="Username"
                            v-model="model.username">
                </base-input>

                <base-input placeholder="Password"
                            type="password"
                            v-model="model.password">
                </base-input>

                <div class="error-message alert alert-danger" v-if="error_message">
                    {{ error_message }}
                </div>

                <div class="text-center">
                    <base-button type="primary" class="btn-block my-4" @click="verifiUser">
                        <span v-if="isLoading">Logging In...</span>
                        <span v-else>Login</span>
                    </base-button>
                </div>

                <div><a href="javascript:void(0);" class="btnRegister" @click="$router.push('register')">Register New Account?</a></div>
                <div class="mt-2"><a href="javascript:void(0);" class="btnRegister" @click="$router.push('forgot-password')">Forgot Password?</a></div>
            </form>
        </div>
        <div class="col-lg-12 text-center">
            <p>For additional information or assistance with the customer login, please contact webmaster.us@torindrivena.com.</p>
        </div>
    </div>
</template>
<script>
  export default {
    name: 'login',
    data() {
      return {
        isLoading: false,
        error_message: false,
        model: {
          action: 'sesLogin',
          username: '',
          password: ''
        }
      }
    },
    methods: {
        checklogin() {
            var user = localStorage.getItem('user');
            if ( user ) {
                this.$router.push('dashboard');
                location.href = '/project/dashboard';
            }
        },
        verifiUser() {
            const api = '/wp-admin/admin-ajax.php';
            this.isLoading = true;
            this.error_message = false;

            let fdata = new FormData;
            fdata.append('action', this.model.action);
            fdata.append('username', this.model.username);
            fdata.append('password', this.model.password);

            this.$http.post(api, fdata)
            .then((response) => {
                this.isLoading = false;
                if ( response.data.status === 'success' ) {
                    localStorage.setItem('user', JSON.stringify(response.data.user));
                    if ( response.data.user.need_reset ) {
                        localStorage.setItem('need_reset', 1);
                        this.$router.push('/reset');
                        location.href = '/project/reset';
                    } else {
                      if (response.data.user.role === 'project-manager' || response.data.user.role === 'administrator' || response.data.user.role === 'super_admin' || response.data.user.type === 'administrative') {
                        this.$router.push({ path: '/projects' });
                        location.href = '/project/projects';
                      } else {
                        this.$router.push('dashboard');
                        location.href = '/project/dashboard';
                      }
                    }
                } else {
                    if ( response.data.message ) this.error_message = response.data.message
                }
            })
            .catch((error) => {
                console.log(error);
                this.isLoading = false;
                if ( error.response.data.message ) this.error_message = error.response.data.message
            });
        },
    },
    beforeMount(){
        this.checklogin()
    }
  }
</script>
<style lang="scss" scoped>
::v-deep .form-control {
    border: 1px solid #102e6c;
    border-radius: 4px;
    font-size: 13px;
    height: 47px;
    padding: 5px 10px;
}
::v-deep .btn-primary {
    padding: 12px 30px;
    width: 100%;
}
.btnRegister {
    margin-top: 1em;
    color: #143e7e;
    &:hover {
        text-decoration: underline;
        color: #143e7e;
    }
}
.error-message{
    color: #a94442;
    background-color: #f2dede;
    border-color: #ebccd1;
    padding: 10px 15px;
    margin-bottom: 20px;
    border: 1px solid transparent;
    border-radius: 4px;
}
</style>
